export const LAST_CATEGORY_ID_FOR_MIGRATION = ['11111', '22222', '33333'];
